import ReactGA from "react-ga4";

export const trackEvent = (category, action, label) => {
  ReactGA.event({ category, action, label });
};

export const trackCTA = (label) => {
  trackEvent("CTA", "click", label);
};

export const trackOutboundLink = (url) => {
  trackEvent("Outbound", "click", url);
};

export const trackFormSubmission = (formName) => {
  trackEvent("Form", "submit", formName);
};
